import { render, staticRenderFns } from "./RealStateLotsList.vue?vue&type=template&id=0bfef688"
import script from "./RealStateLotsList.vue?vue&type=script&lang=js"
export * from "./RealStateLotsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports